import * as React from "react";
import { Divider, Box, Typography } from "@mui/material";

// ** import children component
import { useSelector } from "react-redux";
import { TrainBook } from "./ResearchDoc/train";

const Dedicate = () => {
  const { user } = useSelector((state: any) => state.auth);

  return (
    user && (
      <Box
        sx={{
          maxHeight: "calc(100vh - 100px)",
          overflowY: "scroll",
          "::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <TrainBook />
      </Box>
    )
  );
};

export default Dedicate;
